module.exports = __webpack_public_path__ + "img/coin-on.3086a733.svg";